import { fabric as a } from "fabric";
const c = ({
  txt: r,
  width: t,
  fontOptions: e
}) => {
  if (!(!r || r.trim().length === 0 || !e))
    return new a.Textbox(r, {
      width: t,
      fill: e.fillColor,
      fontFamily: e.fontFamily,
      fontStyle: e.fontStyle,
      fontWeight: e.fontWeight,
      fontSize: e.fontSize,
      opacity: e.fontOpacity / 100
    });
}, o = ({
  width: r,
  height: t,
  fillColor: e,
  opacity: i
}) => new a.Rect({
  fill: e,
  width: r,
  height: t,
  rx: 4,
  ry: 4,
  opacity: i / 100
});
export {
  o as createHeaderTxtboxContainer,
  c as createHeaderTxtboxFabricObj
};
//# sourceMappingURL=index.es398.js.map
